/** @jsx jsx */
import * as React from 'react';
import { Fragment } from 'react';
import { jsx } from '@balance-web/core';
import { DeprecatedButton } from '@balance-web/button-deprecated';
import { Heading } from '@balance-web/heading';
import { Stack } from '@balance-web/stack';
import { Text } from '@balance-web/text';
import { TextLink } from '@balance-web/text-link';
import { CloudOffIcon } from '@balance-web/icon';
import type { PropsWithChildren } from 'react';

import { Fullscreen } from '../../generic/Fullscreen';

export type ErrorScreenProps = {
  title?: string;
  image?: React.ReactNode;
  description?: string;
  refreshButtonLabel?: string;
  onRefreshClick?: () => void;
};

export const ErrorScreen: React.FC<PropsWithChildren<ErrorScreenProps>> = ({
  title = 'Oops, something went wrong',
  image,
  refreshButtonLabel = 'Refresh Page',
  onRefreshClick,
  children,
  ...props
}) => {
  return (
    <Fullscreen {...props}>
      <Stack align="center" gap="xlarge">
        {image || <CloudOffIcon color="textTertiary" size="large" />}

        <Heading align="center" level="4">
          {title}
        </Heading>

        <Text color="textBody" size="small">
          {children || (
            <Fragment>
              The issue may be temporary. Please try again. If the problem
              persists, get in touch with our friendly support team.{' '}
              <TextLink href="/settings/help-and-support">
                Learn more ›
              </TextLink>
            </Fragment>
          )}
        </Text>

        {onRefreshClick && (
          <DeprecatedButton
            block
            label={refreshButtonLabel}
            size="medium"
            onClick={onRefreshClick}
          />
        )}
      </Stack>
    </Fullscreen>
  );
};
